var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoFlechaRightMenuLateral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.71 25.63",
    style: {
      enableBackground: "new 0 0 14.71 25.63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7367F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    className: "st0",
    d: "M10.36,12.8L0.82,3.26c-0.7-0.7-0.71-1.83-0.01-2.54c0,0,0.01-0.01,0.01-0.01 c0.71-0.7,1.84-0.7,2.55,0l10.81,10.8c0.68,0.68,0.7,1.78,0.05,2.49L3.38,24.88c-0.7,0.7-1.84,0.71-2.55,0 c-0.7-0.7-0.71-1.84,0-2.55l0,0L10.36,12.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFlechaRightMenuLateral);
export default __webpack_public_path__ + "static/media/icono-flecha-right-menu-lateral.284ef9caf0344a083050bbc2d8b961c8.svg";
export { ForwardRef as ReactComponent };